import { createRouter, createWebHistory } from "vue-router";

import AuditPPPFrontChildrens from "./audit-ppp-front/childrens";

import { useAuth, useOidcStore } from "vue3-oidc";
import { useUserStore } from "@/store/user.js";
import { toRaw } from "vue";

const OidcCallback = () => import("@/components/OidcCallback.vue");
const AuditPPPFront = () => import("@/components/AuditPPPFront.vue");
const Admin = () => import("@/components/audit-ppp-front/Admin.vue");

const routes = [
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/",
    component: AuditPPPFront,
    children: AuditPPPFrontChildrens,
  },
  {
    path: "/admin",
    component: Admin,
    name: "Admin",
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "Survey";
  if (to.meta.isPublic) {
    next();
    return;
  }

  const { signinRedirect } = useAuth();
  const oidcStore = useOidcStore();
  const userStore = useUserStore();
  const userManager = oidcStore.state.value?.userManager;
  let user = oidcStore.state.value.user;
  // If user is not set, try to get it from the userManager
  if (!user && userManager) {
    user = await userManager.getUser();
    if (user) {
      oidcStore.actions.value.setUser(user);
    }
  }
  if (!user && !to.meta.isPublic) {
    signinRedirect({ state: { redirectPath: to.fullPath } });
    return;
  }

  // Fetch user profile after authentication is confirmed
  if (!userStore.userProfile) {
    try {
      await userStore.fetchCurrentUser();
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  }

  console.log("User profile:", toRaw(userStore.userProfile));
  console.log("User roles:", toRaw(userStore.userProfile?.groups));

  next();
});

export default router;
